import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
    components: {ToastificationContent},
    methods: {
        doCopy(data) {
            var orderIdField = document.createElement("textarea");
            orderIdField.innerText = data;
            document.body.appendChild(orderIdField);
            orderIdField.select();
            document.execCommand("copy");
            orderIdField.remove();
        }
    }
}
